import React from 'react'

import { PillListIcon } from 'app/pages/Communication/Chat/constants'

import * as styles from './styles'

import Pill from '../Pill'

const PillList = (props) => {
  const {
    data = {},
    pillStyles = {},
    isSelected,
    truncationLength,
    singleIconList = false,
    singleIconUrl,
    showPillIcon
  } = props

  return (
    <>
      <styles.PillListContainer>
        {Object?.entries(data)?.map(([key, value]) => {
          return value?.toLowerCase() ? (
            <Pill
              url={singleIconList ? singleIconUrl : PillListIcon[key]}
              text={value?.toLowerCase()}
              pillStyles={pillStyles}
              isSelected={isSelected}
              truncationLength={truncationLength}
              showPillIcon={showPillIcon}
            />
          ) : null
        })}
      </styles.PillListContainer>
    </>
  )
}

export default PillList
